import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/no-multi-comp, react/prefer-stateless-function */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Provider } from '../context';
import { defaultResolver } from '../constants';

var AssetsProvider = function (_PureComponent) {
  _inherits(AssetsProvider, _PureComponent);

  function AssetsProvider() {
    _classCallCheck(this, AssetsProvider);

    return _possibleConstructorReturn(this, (AssetsProvider.__proto__ || _Object$getPrototypeOf(AssetsProvider)).apply(this, arguments));
  }

  _createClass(AssetsProvider, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Provider,
        { value: this.props.resolver },
        this.props.children
      );
    }
  }]);

  return AssetsProvider;
}(PureComponent);

AssetsProvider.propTypes = {
  /**
   * Function that receives asset 'name' as a first parameter
   * and should return React component or Promise that will be resolved to React component.
   * React component can be 'class' or 'function'.
   *
   * @param name {string} - name of asset
   * @returns - {React#Component | Promise}
   */
  resolver: PropTypes.func,
  /** Content to be displayed */
  children: PropTypes.node
};
AssetsProvider.defaultProps = {
  resolver: defaultResolver
};
export default AssetsProvider;